import { render, staticRenderFns } from "./RevenueByProductTable.vue?vue&type=template&id=3dd93738&"
import script from "./RevenueByProductTable.vue?vue&type=script&lang=ts&"
export * from "./RevenueByProductTable.vue?vue&type=script&lang=ts&"
import style0 from "./RevenueByProductTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports